import ROLES from "../../constants/roles";

export const hideSSN = (SSN: number): string => {
	let hiddenSSN = "***-**-";
	const strSSN = String(SSN);

	for (let idx = 5; idx < strSSN.length; idx++) {
		hiddenSSN = hiddenSSN + strSSN[idx];
	}

	return hiddenSSN;
};

export const formatSSN = (SSN: string): string => {
	return SSN.substring(0, 3) + "-" + SSN.substring(3, 5) + "-" + SSN.substring(5);
};

export const formatSSNHide = (ssn: string, visible = false) => {
	if (!ssn) return "";
	if (visible) return ssn;
	const last4 = ssn.slice(-4);
	return `XXX-XX-${last4}`;
};

export const UIFormatSSN = (SSN: string): string => {
	if (SSN.includes("@")) return SSN.replaceAll("@", "");

	return SSN;
};

export const handleSSNFormat = (user: any, SSN: string): string => {
	console.log("checkingthis@ssn-->", SSN);
	if (!SSN) return "";
	// Remove trailing @ if present
	const sanitizedSSN = SSN.endsWith("@") ? SSN.slice(0, -1) : SSN;
	const lastFour = sanitizedSSN.slice(-4);
	return `XXX-XX-${lastFour}`;
};

export const handleSSNFormatForView = (user: any, SSN: string): string => {
	// console.log("Hittingthisshit");
	const formattedSSN = SSN.substring(0, 3) + "-" + SSN.substring(3, 5) + "-" + SSN.substring(5);
	return UIFormatSSN(formattedSSN);
};
